import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/blogs/[identifier]/BlogContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/CloudImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/HeroSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MediaContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
